import React, { ChangeEvent, useId } from 'react';
import clsx from 'clsx';

import { Icon } from '@/stories/atoms/Icon/Icon';
import { FormItem } from '@/stories/components/Form/FormItem/FormItem';
import { FieldProps } from './Input/Input';
import styles from '@/stories/components/Form/Input/input.module.css';

export type TextareaProps = React.ComponentProps<'textarea'> & FieldProps

export const Textarea = ({value, setValue, label, id, required = false, helpText, errorText, hideLabel, icon, variant, ...props}: TextareaProps) => {
  const generatedId = useId()

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const {value} = e.target
    if (setValue) setValue(value as string)
  }

  return (
    <FormItem id={id || generatedId} label={label} hideLabel={hideLabel} required={required} helpText={helpText} errorText={errorText}>
      <div className={clsx(styles.wrapper, icon && 'has-icon')}>
        {icon ? <Icon icon={icon} className={styles.icon}/> : null}
        <textarea
          className={clsx(styles.input, styles.textarea, variant && styles[variant])}
          id={id || generatedId}
          value={value}
          onChange={handleChange}
          {...props}/>
      </div>
    </FormItem>
  )
};
